import React, {createContext, useContext, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useFormik, FormikProvider} from 'formik';
import {checkEmailIsValid} from '../../_common/utils/checkEmailIsValid';
import {usePriceQuotesPageContext} from './PriceQuotesPageContext';
import {getPriceQuoteDetails} from '../_redux/actions/PopupCreateEditPriceQuoteActions';
import {createLink} from '../_redux/actions/PopupCreateLinkActions';

const CreateLinkContext = createContext('');

export function useCreateLinkContext() {
  return useContext(CreateLinkContext);
}

export function CreateLinkProvider({children}) {
  const dispatch = useDispatch();
  const {linkPriceQuoteID, setLoading} = usePriceQuotesPageContext();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (linkPriceQuoteID) {
      setLoading(true);
      getPriceQuoteDetails(linkPriceQuoteID)
        .then(setData)
        .finally(() => setLoading(false));
    }
  }, [linkPriceQuoteID]);

  const customers = data?.priceQuote?.customers ? data?.priceQuote?.customers : [];
  const priceQuoteEmails = Array.isArray(customers)
    ? customers.map(item => item?.email).filter(Boolean)
    : [];
  const uniqueEmails = priceQuoteEmails
    .filter((item, index) => priceQuoteEmails.indexOf(item) === index);

  const formik = useFormik({
    initialValues: {
      email: '',
      notes: '',
      password: '',
      passwordHint: '',
    },
    validate: (values) => {
      let errors = {};
      if (!values.email) errors.email = 'Email is required';
      if (values.email && !checkEmailIsValid(values.email)) errors.invalidEmail = 'Invalid email address';
      if (values.password && !values.passwordHint) errors.passwordHint = 'Password hint is required';
      return errors;
    },
    validateOnMount: true,
    onSubmit: () => {
    },
    enableReinitialize: true,
  });

  const handleCreate = async () => {
    try {
      await dispatch(createLink({
        priceQuoteID: linkPriceQuoteID,
        sentTo: formik.values.email,
        notes: formik.values.notes,
        password: formik.values.password ? formik.values.password : '',
        passwordHint: formik.values.passwordHint,
      }))
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <CreateLinkContext.Provider
      value={{
        formik,
        handleCreate,
        uniqueEmails
      }}
    >
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </CreateLinkContext.Provider>
  );
}
